import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-report-doc-arranger',
  templateUrl: './report-doc-arranger.component.html',
  styles: [
  ]
})
export class ReportDocArrangerComponent extends ExcTranslation implements OnInit, OnChanges {
  @Input() vorgOrAuNr = '';
  @Input() selectKey = '';
  @Input() addObj = '';
  @Input() deleteObj = '';
  @Output() arrangementArrayChange = new EventEmitter<any[]>();

  arrangementArray = [] as any[];

  // altes modal
  selectedItem: any = null;
  documentDataPreview: any = {};
  isLoadingPreview = false;
  isPhotoDocPreview = false;
  photoDocPagesPreview: any[] = [];

  constructor(
    public excRest: ExcRestService,
    private modal: ExgModalService,
    public enmSrv: EnumerationService,
    public excSecurity: ExcSecurityService
  ) { super(); }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addObj?.currentValue) {
      const newObj = {
        ...changes.addObj.currentValue,
        availablePageCount: this.getAvailablePages(changes.addObj.currentValue),
        selectedPages: []
      };
      this.arrangementArray.push(newObj);
      if (this.arrangementArray.length === 1) { this.selectItem(this.arrangementArray[0]); }
    }

    if (changes?.deleteObj?.currentValue) {
      const deleteId = this.extractId(changes.deleteObj.currentValue);
      this.arrangementArray = this.arrangementArray.filter(item => this.extractId(item) !== deleteId);

      if (this.selectedItem && this.extractId(this.selectedItem) === deleteId) {
        this.selectedItem = null;
      }
    }

    // Wichtig: immer nach Änderungen emitten
    this.arrangementArrayChange.emit(this.arrangementArray);
  }


  // page selector modal
  selectItem(item: any): void {
    this.selectedItem = item;
    this.loadPreviewData();
  }

  private loadPreviewData(): void {
    if (!this.selectedItem) {
      return;
    }

    if (!this.selectedItem.selectedPages || this.selectedItem.selectedPages.length === 0) {
      const totalPages = this.getAvailablePages(this.selectedItem);
      this.selectedItem.selectedPages = this.generatePageNumbers(totalPages);
    }

    if (this.selectedItem.dokID && this.selectedItem.dokMIME === 'application/pdf') {
      this.isLoadingPreview = true;
      this.isPhotoDocPreview = false;

      this.excRest.get(
        this.excRest.computeUrl('DocumentR', { dokID: this.selectedItem.dokID }), {}
      ).subscribe((response: any) => {
        if (response.success) {
          this.documentDataPreview = response.data;
        }
        this.isLoadingPreview = false;
      });
    } else if (this.selectedItem.pdID) {
      this.isLoadingPreview = true;
      this.isPhotoDocPreview = true;
      this.loadPhotoDocumentationPicsPreview();
    }
    else if (this.selectedItem.cvID) {
      this.isLoadingPreview = true;
      this.isPhotoDocPreview = false;
      this.loadCalculationPreview();
    }
    else {
      this.documentDataPreview = {};
      this.isPhotoDocPreview = false;
    }
  }
  private loadCalculationPreview(): void {
    this.documentDataPreview = {
      dokPages: this.selectedItem.SheetCount || this.selectedItem.VisibleSheetCount || 1
    };
    this.isLoadingPreview = false;
  }

  getCalculationPagePreviewUrl(pageNum: number): string {
    if (!this.selectedItem?.cvID) {
      return '';
    }

    return this.excRest.computeUrl('CalculationVersionR_Preview', {
      cvID: this.selectedItem.cvID,
      page: pageNum - 1,
      thumb: 1200
    });
  }
  public loadPhotoDocumentationPicsPreview(): void {
    const pdData = JSON.parse(this.selectedItem.pdData);
    this.photoDocPagesPreview = pdData.pages || [];

    this.documentDataPreview = {
      dokPages: this.photoDocPagesPreview.length
    };

    this.isLoadingPreview = false;
  }

  generatePageNumbers(totalPages: number): number[] {
    const pageNumbers: number[] = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  }

  // getPhotoDocPagePreviewUrl(pageIndex: number): string {
  //   if (!this.isPhotoDocPreview || !this.photoDocPagesPreview[pageIndex - 1]) {
  //     return '';
  //   }
  //
  //   const page = this.photoDocPagesPreview[pageIndex - 1];
  //   const firstImage = page.images && page.images[0];
  //
  //   if (firstImage && firstImage.dokID) {
  //     return this.excRest.computeUrl('ImageThumbnailBig', {
  //       dokID: firstImage.dokID,
  //       page: (firstImage.page || 1) - 1
  //     });
  //   }
  //
  //   return '';
  // }
  getPhotoDocPagePreviewUrl(image: any): string {
    if (!image?.dokID) { return ''; }

    return this.excRest.computeUrl('ImageThumbnailBig', {
      dokID: image.dokID,
      page: (image.page || 1) - 1
    });
  }
  getPdfPagePreviewUrl(pageNum: number): string {
    if (!this.selectedItem?.dokID || this.selectedItem?.dokMIME !== 'application/pdf') {
      return '';
    }

    return this.excRest.computeUrl('ImageThumbnailBig', {
      dokID: this.selectedItem.dokID,
      page: pageNum - 1
    });
  }
  onPageSelectionChange(page: number, event: Event): void {
    if (!this.selectedItem) {
      return;
    }

    const target = event.target as HTMLInputElement;
    const isSelected = target.checked;

    if (!this.selectedItem.selectedPages) {
      this.selectedItem.selectedPages = [];
    }

    if (isSelected) {
      if (!this.selectedItem.selectedPages.includes(page)) {
        this.selectedItem.selectedPages.push(page);
        this.selectedItem.selectedPages.sort((a: number, b: number) => a - b);
      }
    } else {
      this.selectedItem.selectedPages = this.selectedItem.selectedPages.filter((p: number) => p !== page);
    }

    this.updatePageCount(this.selectedItem, this.selectedItem.selectedPages.length);
  }

  togglePageSelection(page: number): void {
    if (!this.selectedItem){
      return;
    }

    if (!this.selectedItem.selectedPages) {
      this.selectedItem.selectedPages = [];
    }

    const isCurrentlySelected = this.selectedItem.selectedPages.includes(page);

    if (isCurrentlySelected) {
      // add
      this.selectedItem.selectedPages = this.selectedItem.selectedPages.filter((p: number) => p !== page);
    } else {
      // del
      this.selectedItem.selectedPages.push(page);
      this.selectedItem.selectedPages.sort((a: number, b: number) => a - b);
    }

    this.updatePageCount(this.selectedItem, this.selectedItem.selectedPages.length);
  }

  // getSelectedPagesTextForItem(item: any): string {
  //   const selectedPages = item.currentSelectedPages;
  //   if (!selectedPages || Object.keys(selectedPages).length === 0) {
  //     return '0';
  //   }
  //
  //   const selectedCount = Object.keys(selectedPages).length;
  //   const pageNumbers = Object.keys(selectedPages).map(Number).sort((a, b) => a - b);
  //   return `${selectedCount} (${pageNumbers.join(', ')})`;
  // }

  hideImage(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target) {
      target.style.display = 'none';
    }
  }
  updatePageCount(item: any, newPageCount: number): void {
    item.selectedPageCount = newPageCount;
  }


  /*Drag and Drop*/
  dropPage(event: CdkDragDrop<{ layout: number;
    top: { dokID: string; comment: string; [p: string]: any }[];
    left: { dokID: string; comment: string; [p: string]: any }[];
    right: { dokID: string; comment: string; [p: string]: any }[];
    bottom: { dokID: string; comment: string; [p: string]: any }[]; [p: string]: any }[], any>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  public extractId(obj: any): any {
    const idKeys = ['cvID', 'qverID', 'pdID', 'dokID', 'rcptID'];
    for (const key of idKeys) {
      if (obj && obj[key] !== undefined) {
        return obj[key];
      }
    }
    return null;
  }

  getAvailablePages(obj: any): number {
    if (obj.cvID) {
      return obj.SheetCount || obj.VisibleSheetCount || 1;
    }
    if (obj.PageCount) {
      return obj.PageCount;
    } else if (obj.dokPages) {
      return obj.dokPages;
    }
    return 1;
  }

  getSelectedPagesText(obj: any): number {
    const selectedPages = obj.selectedPages;
    if (!selectedPages || selectedPages.length === 0) {
      return this.getAvailablePages(obj);
    }
    return selectedPages.length;
  }

  logArrangementArray(): void {
    console.log('arrangementArray' + this.arrangementArray);
  }
}
